import s from './style.css';
import cn from 'classnames';
import { Link } from 'preact-router/match';

const LinkBlock = ({
	links = {},
	TagName = 'div',
	LinkType = Link,
	tight = false,
	highlightActive = true,
	target
}) => {
	const extras = {};
	if (target) {
		extras.target = target;
	}

	return (
		<TagName>
			{Object.entries(links).map(([link, name], i) => (
				<span>
					{i !== 0 ? ' ' : ''}
					<LinkType
						className={cn(s.link, { [s.tight]: tight })}
						activeClassName={highlightActive ? s.active : null}
						href={`${link}`}
						rel="noopener" target={!link.includes('mailto:') ? target : null}
					>
						<span className={s.linkWrapper}>{name}</span>
					</LinkType>
				</span>
			))}
		</TagName>
	);
};

export default LinkBlock;



// WEBPACK FOOTER //
// ./components/linkBlock/index.js